import { useNavigate } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { Button } from './button';

export interface AccesRefuseProps {
  /** Message principal (défaut : message 403 standard de l'ERP). */
  message?: string;
  /** Précision optionnelle (ex : nom de la permission requise). */
  detail?: string;
  /** Destination du bouton de repli (défaut : tableau de bord « / »). */
  retourTo?: string;
}

/**
 * Page 403 « Accès refusé » explicite et réutilisable.
 *
 * Remplace toute redirection silencieuse : l'utilisateur comprend pourquoi il
 * est bloqué et dispose d'un bouton pour repartir. À utiliser sur tous les
 * écrans protégés par une permission (ex : périmètre financier « controle_couts »).
 */
export function AccesRefuse({ message, detail, retourTo = '/' }: AccesRefuseProps) {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center rounded-lg border border-dashed border-border bg-surface-secondary px-6 text-center">
      <span className="flex size-14 items-center justify-center rounded-full bg-status-stuck/10 text-status-stuck">
        <ShieldX className="size-7" />
      </span>
      <h2 className="mt-5 text-xl font-bold text-content-primary">Accès refusé</h2>
      <p className="mt-2 max-w-md text-sm text-content-secondary">
        {message ?? "Vous n'avez pas les droits nécessaires pour accéder à cette section."}
      </p>
      <p className="mt-1 max-w-md text-sm text-content-muted">
        {detail ?? "Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur."}
      </p>
      <Button className="mt-6" variant="secondary" onClick={() => navigate(retourTo)}>
        Retour au tableau de bord
      </Button>
    </div>
  );
}
